import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { RaisinContainer as Container } from '@raisin/components-lib';
export const Wrapper = styled(Grid)(() => ({}));
export const ImageContainer = styled('div')(({ theme }) => ({
    padding: theme.spacing(6, 0),
    [theme.breakpoints.down('md')]: {
        padding: theme.spacing(4, 0),
    },
}));
export const FooterDescription = styled(Box)(({ theme }) => ({
    padding: theme.spacing(6, 6, 6, 0),
    maxWidth: 360,
    [theme.breakpoints.down('md')]: {
        maxWidth: '100%',
        padding: theme.spacing(4, 0),
    },
}));
export const CustomImage = styled('img')(() => ({
    maxWidth: 124,
    minWidth: 0,
    maxHeight: 28,
}));
export const GridContainer = styled(Container)(({ theme }) => ({
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(10),
}));
export const Heading = styled('h5')(() => ({
    margin: 0,
    fontSize: 18,
    lineHeight: 1.44,
    userSelect: 'none',
}));
export const Anchor = styled('a')(({ theme }) => ({
    display: 'flex',
    marginTop: theme.spacing(2.5),
    color: theme.palette.black80.main,
    textDecoration: 'none',
}));
//# sourceMappingURL=styles.js.map